/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayOrientationToggle_ConfigFragment = { __typename: 'ConfigurationModel', id: string, orientation?: { __typename: 'ConfigOrientationState', reported: Types.ConfigOrientation, supportedValues: Array<Types.ConfigOrientation> } | null };

export type ConfigUpdateOrientationMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateOrientationInput;
}>;


export type ConfigUpdateOrientationMutation = { __typename: 'Mutation', configurationUpdateOrientation: { __typename: 'ConfigurationModel', id: string, orientation?: { __typename: 'ConfigOrientationState', reported: Types.ConfigOrientation, supportedValues: Array<Types.ConfigOrientation> } | null } };

export const ConfigDisplayOrientationToggle_ConfigFragmentDoc = gql`
    fragment ConfigDisplayOrientationToggle_config on ConfigurationModel {
  id
  orientation {
    reported
    supportedValues
  }
}
    `;
export const ConfigUpdateOrientationDocument = gql`
    mutation ConfigUpdateOrientation($input: ConfigurationUpdateOrientationInput!) {
  configurationUpdateOrientation(input: $input) {
    ...ConfigDisplayOrientationToggle_config
  }
}
    ${ConfigDisplayOrientationToggle_ConfigFragmentDoc}`;
export type ConfigUpdateOrientationMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateOrientationMutation, ConfigUpdateOrientationMutationVariables>;

/**
 * __useConfigUpdateOrientationMutation__
 *
 * To run a mutation, you first call `useConfigUpdateOrientationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateOrientationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateOrientationMutation, { data, loading, error }] = useConfigUpdateOrientationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateOrientationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateOrientationMutation, ConfigUpdateOrientationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateOrientationMutation, ConfigUpdateOrientationMutationVariables>(ConfigUpdateOrientationDocument, options);
      }
export type ConfigUpdateOrientationMutationHookResult = ReturnType<typeof useConfigUpdateOrientationMutation>;
export type ConfigUpdateOrientationMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateOrientationMutation>;
export type ConfigUpdateOrientationMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateOrientationMutation, ConfigUpdateOrientationMutationVariables>;